import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { FactoryNavigationBar } from '../component/navigation-bar/FactoryNavigationBar';
import { SertMqttDiv } from '../component/sert-mqtt/SertMqttDiv';

export const SertMqttPage = () => (
  <MainPageLayout
    navigationBar={<FactoryNavigationBar />}
    elementCentr={<SertMqttDiv />}
  />
);
